export default __webpack_public_path__ + "/dist/images/billings-inactive.845c5a4d9dccecacd14f7461e3d0910c.svg";